import { render } from "./BenefitsCalculatorResultsPage.vue?vue&type=template&id=5ca71b8a&scoped=true"
import script from "./BenefitsCalculatorResultsPage.vue?vue&type=script&lang=js"
export * from "./BenefitsCalculatorResultsPage.vue?vue&type=script&lang=js"

import "./BenefitsCalculatorResultsPage.vue?vue&type=style&index=0&id=5ca71b8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca71b8a"]])

export default __exports__